export default "__VITE_ASSET__3xn6YGTk__"